import React from 'react';
import { IField } from '../../../../shared/interfaces';
import DynamicForm from '../../../DynamicForm/DynamicForm';
import CircleLoader from '../../../Loader/CircleLoader/CircleLoader';

export interface RemoteSignFormProps {
    loading?: boolean
    extraCssClass?: string
    fields: IField[]
    onInputChangedHandler: (newField: IField) => void
}


const RemoteSignForm: React.FunctionComponent<RemoteSignFormProps> = (props) => {

    let loading = props.loading !== undefined ? props.loading : false;

    return (
        <React.Fragment>

            <CircleLoader loaderClass='loader-large' loading={loading} />

            <DynamicForm
                fields={props.fields}
                onInputChangedHandler={(newField) => { props.onInputChangedHandler(newField) }}
            />

        </React.Fragment>
    );
}


export default RemoteSignForm;